var app_slider = null;
(function ($) {
    'use_strict';
    app_slider = function (_element, _min, _max, _input, _perfix, _callBack) {

        var self = this;
        self.element = _element;
        self.min = _min;
        self.max = _max;
        self.perfix = _perfix;
        self.input = _input;

        self.buildSlider = function () {

            

            self.element.slider({
                range: true,
                min: self.min,
                max: self.max,
                "values": [self.min, self.max],
                slide: function (event, ui) {
                    self.startV = addCommas(ui.values[0])
                    
                    if (self.startV == '0') {
                        self.startV = '0' + " " + self.perfix;
                    }
                    self.endV = addCommas(ui.values[1])
                    
                    if (self.endV == '0') {
                        self.endV = '0' + " " + self.perfix;
                    }
                    self.setInputValue(self.startV, self.endV);
                    _callBack();
                    // repeat for delayed touch releaase
                    setTimeout(_callBack, 200);
                }
            });

            
            self.setInputValue(addCommas(self.element.slider("values", 0)), addCommas(self.element.slider("values", 1)));

        };  

        self.setInputValue = function (value1, value2) {
            if (self.perfix !== false) {
                if(value1 == "-"){
                    value1 = "0";
                }
                if(value2 == "-"){
                    value2 = "0";
                }
                self.input.val(value1 + " " + self.perfix + " - " + value2 + " " + self.perfix);
            } else {
                self.input.val(value1 + " - " + value2);
            }
        };

        self.buildSlider(); 

        return self;
    };

})(jQuery);